import { render, staticRenderFns } from "./adjustArticlePicture.vue?vue&type=template&id=3489912c&scoped=true&"
import script from "./adjustArticlePicture.vue?vue&type=script&lang=js&"
export * from "./adjustArticlePicture.vue?vue&type=script&lang=js&"
import style0 from "./adjustArticlePicture.vue?vue&type=style&index=0&id=3489912c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489912c",
  null
  
)

export default component.exports